import React from 'react';
import '../style/formGroupTextInput.css'
import EditIcon from "./icons/editIcon";
import DeleteIcon from "./icons/deleteIcon";
import InfoIcon from "./icons/infoIcon";
import {checkIfQuestionAnswerUpdateRequiresARAGApproval} from "../helpers/approvalSettings/functions";
import {INFO_TEXT_EDIT_WITH_APPROVAL, INFO_TEXT_EDIT_WITHOUT_APPROVAL} from "../helpers/variables";


const FormGroupPlainTableRow = (props) => {
	let breachCausationCp = props.breachCausationCp.options.filter(item => item.id === props.Data.breachCausationCpId)[0];

	return (
		<tr className="appFormRefSettings-tr">
			<td>
				<div className="">
					{props.Data.name}
				</div>
			</td>
			<td>
				<div className="">
					{props.Data.natureOfExpert}
				</div>
			</td>
			<td>
				<div className="">
					{props.Data.whySpecificExpert}
				</div>
			</td>
			<td>
				<div className="">
					{breachCausationCp?breachCausationCp.name:''}
				</div>
			</td>
			<td>
				<div className="">
					{props.Data.partialEstimatedCost}
				</div>
			</td>
			<td>
				<div className="">
					{props.Data.attendanceEstimatedCost}
				</div>
				<div className="formGroupTableRow-actions-wrapper" style={{top: "10px"}}>
					{(props.Data.id && props.areRowsEditable) && (
						<EditIcon
							informationText={
								props.changesRequriesARAGApproval
									? INFO_TEXT_EDIT_WITH_APPROVAL : INFO_TEXT_EDIT_WITHOUT_APPROVAL
							}
							className={props.changesRequriesARAGApproval? "edit-icon--orange" : null}
							onClick={() => props.onEditRowClick(props.Data.id)}
						/>
					)}
					{(props.totalRows > 1 && props.areRowsEditable) && (
						<DeleteIcon
							className={props.changesRequriesARAGApproval? "delete-icon--orange" : null}
							onClick={() => props.onDeleteRowClick(props.Data, props.editingSetting)}
						/>
					)}
					{(props.checkIfRowHasBeenModified && props.checkIfRowHasBeenModified(props.Data.id))  && (
						<InfoIcon
							className={props.changesRequriesARAGApproval? "info-icon--orange" : null}
							onClick={() => props.onInfoClick(props.Data.id)}
						/>
					)}
				</div>
			</td>
		</tr>
	)
};

export default FormGroupPlainTableRow;